<template>
  <div class="report">
    <el-dialog ref="reportDialog"
               :visible.sync="showDialog"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               custom-class="window"
               :width="dialogWidth"
               top="10vh"
               :fullscreen="true"
               :show-close="false"
               :title="$t('labor.Create Report')">
      <div class="reportdiv"
           ref="reportDiv"
           :style="{height:reportDivHeight}">
        <myScroll class="labor-table-scroll">
          <div v-loading="loading"
               class="report-content"
               id="reportContentDiv">
            <div class="TaskReportVessel"
                 id="TaskReportVessel">
              <div class="top-company-info">
                <div class="report-header-info">
                  <div class="corp-logo">
                    <img id="corpImg"
                         :src="corpLogo">
                  </div>
                  <ul id="right-info"
                      class="corpInfo">
                    <li>
                      <div class="report-main-title"><span id="report-title">{{$t('labor.BillingReportTitle')}}</span>
                      </div>
                    </li>
                    <li id="corpName"
                        style="font-size: 18px; font-weight: bold">{{CorpName}}</li>
                    <li id="corpAddress">{{address}}</li>
                    <li id="corpEmail">{{ContactEmail}}</li>
                  </ul>
                </div>
                <div class="report-title-info">
                  <div class="info-body project-info-span">
                    <div class="left">
                      <p><span id="project-name-title"
                              class="info-header">{{$t('labor.Job Name:')}} </span>
                        <span id="project-name"
                              class="info-content">{{reportHeaderData.JobsiteName}}</span>
                      </p>
                      <p><span id="trades-title"
                              class="info-header">{{$t('labor.Trades:')}} </span>
                        <span id="trades"
                              class="info-content">{{reportHeaderData.TradesStr}}</span>
                      </p>
                      <!--       <p><span id="retainage-rate-title"
                              class="info-header">{{$t('labor.Retainage Rate:')}} </span>
                        <span id="retainage-rate"
                              class="info-content">{{reportHeaderData.RetainageRate}}%</span>
                      </p> -->
                      <p><span id="billing-date-range-title"
                              class="info-header">{{$t('labor.Billing Date Range:')}} </span>
                        <span id="billing-date-range"
                              class="info-content">{{reportHeaderData.LaborDateRange}}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-content labor-table-div">
                <div class="group">
                  <div class="table__header-wrapper">
                    <table cellspacing="0"
                           cellpadding="0"
                           border="0"
                           class="labor-content">
                      <thead class="has-gutter">
                        <tr class="">
                          <th style="min-width:180px;">
                            <div class="cell"><span class="header-text">{{$t('labor.Description of Work')}}</span></div>
                          </th>
                          <th style="min-width:190px;">
                            <div class="cell">
                              <span class="header-text"
                                    style="color: rgb(230, 162, 60);">{{$t('labor.Previous Billings')}}</span>
                            </div>
                          </th>
                          <th style="min-width:190px;">
                            <div class="cell">
                              <span class="header-text"
                                    style="color: rgb(103, 194, 58);">{{$t('labor.Current Billing')}}</span>
                            </div>
                          </th>
                          <th style="min-width:190px;">
                            <div class="cell">
                              <span class="header-text"
                                    style="color: rgb(64, 158, 255);">{{$t('labor.Total Completed')}}</span>
                            </div>
                          </th>
                          <th style="min-width:190px;">
                            <div class="cell">
                              <span class="header-text"
                                    style="color: rgb(245, 108, 108);">{{$t('labor.Uncompleted')}}</span>
                            </div>
                          </th>
                          <th style="min-width:100px;">
                            <div class="cell"><span>{{$t('labor.Retainage')}}</span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody v-for="plan in laborDatas"
                             :key="plan.PlanId">
                        <tr class="plan-row">
                          <td colspan="6">
                            <div class="plan-box">
                              <h3 class="plan-name">{{plan.PlanName}}</h3>
                            </div>
                          </td>
                        </tr>
                        <tr class="plan-product-row"
                            v-for="item in plan.Items"
                            :key="item.EstimationId">
                          <td>
                            <div class="cell">
                              <div class="sku">{{item.DescriptionOfWork.SKU}}</div>
                              <div class="tag-box-big">
                                <span>${{$config.numberFormat(item.ContractAmount)}} ({{$config.numberFormat(item.DescriptionOfWork.Amount)}} {{item.DescriptionOfWork.Unit}} X ${{$config.numberFormat(item.DescriptionOfWork.UnitCost)}})</span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="cell">
                              <div class="tag-box">
                                <span type="primary"
                                      class="left">${{item.PreviousBillings.Amount?$config.numberFormat(item.PreviousBillings.Amount):'0'}}</span>
                                <span type="primary"
                                      class="right"
                                      style="color: rgb(245, 108, 108);">{{item.PreviousBillings.showRate}}%</span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="cell">
                              <div class="tag-box">
                                <span type="success"
                                      size="small"
                                      class="left">{{$config.numberFormat(item.CurrentWorkBilling.InstalledAmount)}} {{item.DescriptionOfWork.Unit}}</span>
                                <span type="success"
                                      size="small"
                                      class="right">${{$config.numberFormat(item.CurrentWorkBilling.BillingPeriod)}}</span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="cell">
                              <div class="tag-box">
                                <span type="primary"
                                      class="left">${{$config.numberFormat(item.TotalCompletedWork.CompletedToDate)}}</span>
                                <span type="primary"
                                      class="right"
                                      style="color: rgb(245, 108, 108);">{{item.TotalCompletedWork.showRate}}%</span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="cell">
                              <div class="tag-box">
                                <span type="danger"
                                      class="left">{{$config.numberFormat(item.UnCompletedWork.UnInstalledMat)}} {{item.DescriptionOfWork.Unit}}</span>
                                <span type="danger"
                                      class="right">${{$config.numberFormat(item.UnCompletedWork.BalanceToFinish)}}</span>
                              </div>
                            </div>
                          </td>
                          <td style="text-align: center;">
                            <div class="cell"> ${{$config.numberFormat(item.Retainage)}}</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="groupSub">
                <div class="sub-box"
                     style="width:350px;">
                  <div class="sub-box-text">
                    <div class="left">{{$t('labor.Previous Billings:')}}</div>
                    <div class="right">${{$config.numberFormat(subTotalData.PreviousBillingsAmount)}}</div>
                  </div>
                  <div class="sub-box-text">
                    <div class="left">{{$t('labor.Current Billing:')}}</div>
                    <div class="right">${{$config.numberFormat(subTotalData.BillingPeriod)}}</div>
                  </div>
                  <div class="sub-box-text">
                    <div class="left">{{$t('labor.Total Completed:')}}</div>
                    <div class="right">${{$config.numberFormat(subTotalData.CompletedToDate)}}</div>
                  </div>
                  <div class="sub-box-text">
                    <div class="left">{{$t('labor.Uncompleted:')}}</div>
                    <div class="right">${{$config.numberFormat(subTotalData.BalanceToFinish)}}</div>
                  </div>
                  <div class="sub-box-text">
                    <div class="left">{{$t('labor.Retainage:')}}</div>
                    <div class="right">${{$config.numberFormat(subTotalData.Retainage)}}</div>
                  </div>
                  <div class="sub-box-text bg">
                    <div class="left">{{$t('labor.Sub Totals:')}}</div>
                    <div class="right">${{$config.numberFormat(subTotalData.ContractAmount)}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </myScroll>
      </div>
      <!--  <div slot="footer"
           class="dialog-footer">
        <el-button size="mini"
                   @click="closeDialog">{{$t('reportDialog.Cancel')}}</el-button>
        <el-button type="primary"
                   id="btnExport"
                   @click="toExport"
                   :disabled="disabled"
                   size="mini">{{$t('labor.Export')}}</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import { getCorpUserById, getCorpById } from '@/api/config'

export default {
  props: {
    showDialog: {
      type: Boolean,
      value: false
    },
    reportHeaderData: {
      type: Object,
      default: null
    },
    laborDatas: {
      type: Array,
      default: null
    },
    subTotalData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      createdOn: null,
      createdBy: null,
      corpLogo: null,
      address: '',
      CorpName: '',
      ContactEmail: '',
      dialogWidth: '768px',
      reportDivHeight: '400px',
      saveLoading: null,
      disabled: false
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'jobsiteName', 'jobsiteLocation', 'userInfo'])
  },
  created () {
    this.getCorpUserById()
    this.getCorpById()
  },
  mounted () {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  watch: {
    showDialog (to, from) {
      if (to === true) {
        this.setDialogWidth()
        setTimeout(() => {
          this.toExport()
        }, 300)
      }
    }
  },
  methods: {
    setDialogWidth () {
      var val = document.body.clientWidth
      if (val < 768) {
        this.dialogWidth = '100%'
      }
      this.setReportDivHeight()
    },
    setReportDivHeight () {
      if (this.$refs.reportDialog.fullscreen || this.dialogWidth >= '1100px') {
        let dialogHeight = document.body.clientHeight - 155
        if (dialogHeight < 400) {
          dialogHeight = 400
        }
        this.reportDivHeight = dialogHeight + 'px'
      } else {
        let dialogHeight = this.$refs.reportDialog.$el.clientHeight
        if (dialogHeight < 545) {
          dialogHeight = 545
        }
        if (dialogHeight > 0) {
          this.reportDivHeight = (dialogHeight - 155) + 'px'
        }
      }
    },
    getCorpUserById () {
      getCorpUserById(0).then(res => {
        this.createdBy = res.LoginAccount
      })
    },
    getCorpById () {
      getCorpById(0).then(res => {
        let addressObj = {
          Street: res.Address,
          City: res.City,
          State: res.State,
          Country: res.Country,
          ZipCode: res.ZipCode
        }
        res.addressText = this.$config.Address(addressObj)
        if (!res.Logo) {
          res.Logo = 'Files\\DefaultLogo\\logo.png'
        }
        this.corpLogo = this.$config.baseURL + '/api/Attachments?path=' + res.Logo
        this.address = res.addressText
        this.CorpName = res.CorpName
        this.ContactEmail = res.ContactEmail
      })
    },
    closeDialog () {
      this.$emit('closeDialog')
    },
    toExport () {
      this.disabled = true
      this.saveLoading = this.$loading({
        lock: true,
        text: this.$t('reportDialog.Loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let that = this
      let param = {
        JobsiteId: this.jobsiteID,
        Name: this.reportHeaderData.TradesStr + ' ' + this.$t('labor.Labor Billing Report-') + this.$config.formatDate(new Date()) + ' - ' + this.jobsiteName,
        IsLandScape: true,
        ReportType: 6
      }
      let reportHtml = document.getElementById('reportContentDiv').innerHTML
      param.Html = reportHtml

      let taskReportVessel = document.getElementById('TaskReportVessel')
      if (taskReportVessel) {
        if (!param.IsLandScape) {
          taskReportVessel.style.width = '1060px'
        } else {
          taskReportVessel.style.width = '100%'
        }
      }
      let config = {
        'headers': {
          'Content-Type': 'application/json;charset=UTF-8', // 设置跨域头部
          'Authorization': 'Bearer ' + this.$store.state.userInfo.Token
        }
      }
      axios.post(this.$config.baseURL + '/api/TaskReports/ReportByHtml?AllowSaveActivity=true', param, config)
        .then((res) => {
          this.$parent.previewReport(res.UId, res.Name)
          that.saveLoading.close()
          this.closeDialog()
        }).catch((err) => {
          console.log(err)
          that.disabled = false
          that.saveLoading.close()
          this.closeDialog()
        })
    }
  },
  components: {
  }
}
</script>

<style lang="scss">
.report {
  .tab {
    height: 10%;
    text-align: center;
    overflow: hidden;
    .el-tabs__item {
      height: 30px;
      line-height: 30px;
    }
  }
}
</style>
<style lang="scss" scoped>
.button-box {
  float: right;
  width: 200px;
  .el-button-group {
    width: 100%;
    .el-button {
      width: 100px;
    }
    .el-button.active {
      background-color: #eaecf0;
      border-color: #eaecf0;
      color: #717171;
    }
  }
}
.reportdiv {
  width: 100%;
  height: 100%;
  .labor-table-scroll {
    width: 100%;
    height: 100;
  }
}
.report-box {
  width: 100%;
  height: 100%;
}
.report-content {
  height: 100%;
  min-width: 600px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -ms-overflow-style: scrollbar;
  font-family: Arial, Helvetica, "Source Sans Pro", "Helvetica Neue", sans-serif;
  font-weight: 400;
  overflow-x: hidden;
  overflow-y: auto;
  color: #303133;
  word-break: break-word;
  .TaskReportVessel {
    padding: 0px;
    border: 0px #3817b0 solid;
    height: auto;
    margin: 0px 10px;
    width: 100%;

    table {
      margin: 0px 0px 20px 0px;
      width: 100%;
    }

    .corp {
      margin-top: 15px;
      overflow: auto;
    }

    .corp img {
      max-width: 130px;
      max-height: 130px;
    }

    .report-header-info {
      margin-top: 15px;
      width: 100%;
      overflow: hidden;
      padding-left: 10px;
      border-bottom: 1px solid #e4e4e4;
      padding-bottom: 20px;
      margin-bottom: 20px;
    }

    .corp-logo {
      left: -5px;
      width: 120px;
      height: 120px;
      position: relative;
      margin: 0 auto;
      padding: 10px;
      float: left;
      border: #f0f0f0 1px solid;
      margin-right: 10px;
    }

    .corp-logo img {
      width: 120px;
      height: 120px;
      object-fit: contain;
    }

    ul.corpInfo {
      width: 100%;
      text-align: left;
    }

    ul.corpInfo li {
      list-style: none;
      font-size: 15px;
      color: #000000;
      word-wrap: break-word;
    }

    .report-main-title {
      font-size: 26px;
      text-align: center;
      height: 50px;
      line-height: 50px;
      font-weight: bold;
      margin-top: 10px;
      margin-bottom: 10px;
      color: #8e8e8e;
    }

    .report-title-info {
      margin-top: 2px;
      overflow: auto;
      border-bottom: 1px solid #e4e4e4;
      padding-bottom: 20px;
    }

    .report-title-info h4 {
      margin-bottom: 2px;
    }

    .report-title-info .left {
      float: left;
      width: 55%;
    }

    .report-title-info .report-title-info-right {
      float: right;
      text-align: left;
      margin-top: 20px;
    }

    .report-title-info {
      width: 100%;
    }

    .report-title-info .right .content {
      display: inline-block;
      margin: 0px 0px 0px 10px;
      text-align: right;
      width: 70px;
      height: 20px;
    }

    .report-title-info .right .title {
      display: inline-block;
      width: 60px;
    }

    .tdHeaderDivClass {
      align-items: center;
      width: 100%;
      font-size: 13px;
    }

    .tdBodyDivClass {
      align-items: center;
      width: 100%;
      word-break: break-word;
    }

    .headerTr {
      background-color: #e1e1e7;
      font-weight: bold;
    }

    .colorTr {
      background-color: #e1e1e7;
    }

    .project-info-span span {
      margin: 5px 0px;
      color: #121212;
    }

    .divider-line-light {
      height: 1px;
      margin-bottom: 20px;
      background: #e4e4e4;
    }

    .left-text div {
      text-align: left;
      font-size: 15px;
      padding-left: 10px;
      line-height: 18px;
      margin: 7px 0px;
    }

    .underlint-text div {
      text-decoration: underline;
      font-size: 12px;
      height: 15px;
      line-height: 15px;
      margin: 0px;
    }

    .left p {
      margin: 5px 0px;
    }

    .pdf-split {
      page-break-after: always;
    }

    .left p .info-header {
      font-size: 14px;
      color: #909399;
    }

    .left p .info-content {
      font-size: 14px;
      margin-left: 10px;
    }

    .group {
      padding: 8px;
      box-sizing: border-box;
      width: 100%;
    }
    .group labor-content {
      width: 100%;
    }
    .group thead {
      color: #909399;
      font-weight: 500;
    }
    .group table th,
    table td {
      border-bottom: 1px solid #ebeef5;
      padding: 8px 0px;
    }
    .group .table__header-wrapper,
    .table__body-wrapper,
    .table__footer-wrapper {
      width: 100%;
    }
    .group .header-text {
      text-align: center;
      display: block;
      width: 100%;
    }
    .group .plan-box {
      width: 100%;
    }
    .group .plan-box h3 {
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .group .tag-box-big {
      width: 100%;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    .group .tag-box-big span {
      display: block;
      font-size: 12px;
    }
    .group .cell {
      width: 100%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      text-overflow: ellipsis;
      white-space: normal;
      word-break: break-all;
      line-height: 23px;
      padding-left: 10px;
      padding-right: 10px;
    }
    .group .sku {
      width: 100%;
      border-bottom: 1px #ddd solid;
      font-size: 14px;
      color: #000;
    }
    .group .tag-box {
      width: 100%;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    .group .tag-box span {
      display: block;
      width: 50%;
      text-align: center;
    }
    .groupSub {
      height: 200px;
      background-color: #fff;
      position: relative;
    }
    .groupSub .sub-box {
      position: absolute;
      right: 20px;
      top: 10px;
      line-height: 25px;
      width: 350px;
    }
    .groupSub .sub-box .bg {
      font-size: 20px;
    }
    .groupSub .sub-box .sub-box-text {
      width: 100%;
      overflow: hidden;
    }
    .groupSub .sub-box .sub-box-text .left {
      width: 50%;
      float: left;
      color: #909399;
      text-align: left;
    }
    .groupSub .sub-box .sub-box-text .right {
      width: 50%;
      float: right;
      text-align: right;
    }
    .group .el-table__empty-text {
      display: none;
    }

    .group .left {
      float: left;
    }
    .group .right {
      float: right;
    }
    .group tr,
    .group tr td {
      page-break-inside: avoid !important;
    }
    .groupSub tr,
    .groupSub tr td {
      page-break-inside: avoid !important;
    }
  }
}
</style>
